import angular from 'angular';
import WelcomeComponent from './welcome.component';
import { routing as RoutingConfig } from './welcome.config';
export default angular.module('invision.customercare.welcome', []).config(RoutingConfig).component('welcome', WelcomeComponent).name;